import request from './request'

// 声音乐园首页
export function getAudioMission(query) {
    return request({
        url: '/huhushare/Audio/getAudioMission',
        method: 'post',
        data: query
    });
}

// 获取往期主题
export function getOldAudioMission(query) {
    return request({
        url: '/huhushare/Audio/getOldAudioMission',
        method: 'post',
        data: query
    });
}

// 分页获取最新回复
export function getNewestReply(query) {
    return request({
        url: '/huhushare/Audio/getNewestReply',
        method: 'post',
        data: query
    });
}

export function getMyAudioReply(query) {
    return request({
        url: '/huhushare/Audio/getMyAudioReply',
        method: 'post',
        data: query
    });
}

export function getSplendidAudioReply(query) {
    return request({
        url: '/huhushare/Audio/getSplendidAudioReply',
        method: 'post',
        data: query
    });
}

export function getNewestAudioReply(query) {
    return request({
        url: '/huhushare/Audio/getNewestAudioReply',
        method: 'post',
        data: query
    });
}

export function addPraise(query) {
    return request({
        url: '/huhushare/Audio/addPraise',
        method: 'post',
        data: query
    });
}

export function audioRank(query) {
    return request({
        url: '/huhushare/Audio/audioRank',
        method: 'post',
        data: query
    });
}

export function audioReport(query) {
    return request({
        url: '/huhushare/Audio/audioReport',
        method: 'post',
        data: query
    });
}


// WEBPACK FOOTER //
// ./src/api/sound.js